import store from '.'

export default {
  install(Vue){
    Vue.prototype.$DataService = {
      test(){
        //console.log('Funcionando');
      },
      alarmas:{
        Parse(){

        },
        Save(alarmas){
            store.dispatch("commitAlarms", alarmas)
        }
      }
    }
  }
}